import {
  E_ChatV8PayloadKind,
  isChatV8PayloadKind,
  type T_ChatV8Event,
} from "@lattice/core-lib/types/chat-v8";
import type { T_ClientTraceAttributes } from "@lattice/frontend/lib/observability/client-trace";

/** Privacy-safe projection of a Chat V8 wire event for temporal diagnostics. */
export function getChatV8EventTraceAttributes(
  event: T_ChatV8Event,
): T_ClientTraceAttributes {
  const base: T_ClientTraceAttributes = {
    category: event.category,
    display_seq: event.displaySeq,
    event_type: event.type,
    has_item: event.itemCuid !== null,
    has_part: event.partCuid !== null,
    has_run: event.runCuid !== null,
    seq: event.seq,
    status: event.status,
    timeline_version: event.timelineVersion,
  };

  if (
    isChatV8PayloadKind(event.payload, E_ChatV8PayloadKind.MESSAGE_PART) &&
    event.payload.partKind === "markdown"
  ) {
    return {
      ...base,
      delta_length:
        "delta" in event.payload ? event.payload.delta.length : undefined,
      is_live: event.payload.live === true,
      live_sequence: event.payload.liveSequence,
      markdown_length: event.payload.markdown.length,
      message_part_role: event.payload.messagePartRole,
      payload_kind: event.payload.kind,
    };
  }

  if (
    isChatV8PayloadKind(event.payload, E_ChatV8PayloadKind.MESSAGE_PART_STREAM)
  ) {
    return {
      ...base,
      is_live: true,
      live_sequence: event.payload.liveSequence,
      markdown_length: event.payload.markdown.length,
      message_part_role: event.payload.messagePartRole,
      payload_kind: event.payload.kind,
    };
  }

  return base;
}
